import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash, EnvelopeSimple, Download } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Subscribers() {
  const [items, setItems] = useState(null);

  const load = async () => {
    const { data } = await api.get("/subscribers");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    await api.delete(`/subscribers/${id}`);
    load();
  };

  const exportCsv = () => {
    if (!items?.length) return;
    const header = "email,name,subscribed_at\n";
    const rows = items.map((s) => `"${s.email}","${(s.name || "").replace(/"/g, '""')}","${s.created_at}"`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `inkspot-subscribers-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="eyebrow text-muted-foreground mb-2">Audience</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-black tracking-tight">Subscribers</h1>
          <p className="mt-2 text-sm text-muted-foreground">Email addresses captured on your public site.</p>
        </div>
        {items?.length ? (
          <Button variant="outline" onClick={exportCsv} className="rounded-none border-foreground" data-testid="export-csv-button">
            <Download size={14} className="mr-1.5" /> Export CSV
          </Button>
        ) : null}
      </div>

      {items === null ? (
        <div className="text-muted-foreground">Loading...</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-border p-12 text-center">
          <EnvelopeSimple size={28} weight="duotone" className="mx-auto" />
          <div className="font-serif text-2xl font-bold mt-3">No subscribers yet</div>
          <p className="mt-2 text-sm text-muted-foreground">A signup form is shown on your public site. Share your URL to start collecting readers.</p>
        </div>
      ) : (
        <div className="border border-border bg-card">
          <div className="grid grid-cols-12 gap-4 px-4 py-3 border-b border-border eyebrow text-muted-foreground">
            <div className="col-span-5">Email</div>
            <div className="col-span-3">Name</div>
            <div className="col-span-3">Subscribed</div>
            <div className="col-span-1 text-right">·</div>
          </div>
          {items.map((s) => (
            <div key={s.id} className="grid grid-cols-12 gap-4 px-4 py-3 border-b border-border last:border-b-0 items-center" data-testid={`subscriber-row-${s.id}`}>
              <div className="col-span-5 font-mono text-sm break-all">{s.email}</div>
              <div className="col-span-3 text-sm">{s.name || <span className="text-muted-foreground">—</span>}</div>
              <div className="col-span-3 text-sm text-muted-foreground">{new Date(s.created_at).toLocaleDateString()}</div>
              <div className="col-span-1 text-right">
                <button onClick={() => remove(s.id)} className="text-muted-foreground hover:text-destructive p-1" aria-label="Remove" data-testid={`subscriber-remove-${s.id}`}>
                  <Trash size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
